import { rem } from 'polished'
import styled from 'styled-components'

export const ImporterUploadStageStyled = styled.div`
  font-size: ${rem(16)};

  max-width: ${rem(640)};
  margin: 0 auto;
`
